
export const LANG_ES_NAME = 'es';

export const LANG_ES_TRANS = {
    'Referred_By': 'Referido por',
    'Search' : 'Buscar',
}
